<div class='FranchiseeControl'>
  <app-select
    (selection)='onFranchiseeSelect($event)'
    *ngIf="column.account_role !== 'franchisee' && column.account_role !== 'vsm' && column.account_role !== 'master'"
    [defaultValue]='column.franchisee_id || null'
    [items]='getFranchisees()'
    [label]="'Select franchisee'"></app-select>
  <mat-icon (click)='resetFranchisee()' *ngIf='column.franchisee_id'>close</mat-icon>
</div>
